// extracted by mini-css-extract-plugin
export default {"primary-grey-bg":"styles_primary-grey-bg__IeKH1","btn-primary":"styles_btn-primary__SvZYL"};